import Button, { ButtonProps } from "./Button";
import Icon from "../Icon";
import { openModal } from "../../store/slices/modals";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../hooks";
import { selectButton } from "../../store/slices/buttons";
import { getClasses } from "../../utils";
import classes from "../../styles/Buttons.module.css";

const StakeButton: React.FC<ButtonProps> = (props) => {
  const { available, disabled, hidden } = useAppSelector(
    selectButton.bind(null, "stake")
  );
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(openModal("stake"));
  };

  if (!available) {
    return (
      <div className={getClasses(classes, "empty", props.className, "stake")}></div>
    );
  }

  return (
    <Button
      name="stake"
      disabled={disabled}
      className={getClasses(classes, props.className, "stake")}
      onClick={onClick}
      available={available}
      hidden={hidden}
      soundEffect="button-click"
      interactionType="click"
    >
      <Icon type="SelectStake" size={55} />
    </Button>
  );
};

export default StakeButton;
